import { render, staticRenderFns } from "./DocumentListing.vue?vue&type=template&id=87da4018&"
import script from "./DocumentListing.vue?vue&type=script&lang=js&"
export * from "./DocumentListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports